var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.19666 7.52935C4.93445 7.78967 4.93445 8.21242 5.19666 8.47273L8.55306 11.8048C8.81528 12.0651 9.24112 12.0651 9.50334 11.8048C9.76555 11.5444 9.76555 11.1217 9.50334 10.8614L6.62103 8L9.50124 5.13862C9.76346 4.8783 9.76346 4.45555 9.50124 4.19524C9.23902 3.93492 8.81318 3.93492 8.55096 4.19524L5.19457 7.52727L5.19666 7.52935Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftButton);
export default __webpack_public_path__ + "static/media/left_button.e01d470787383c3e036a4603b8f215d9.svg";
export { ForwardRef as ReactComponent };